"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserGroup = void 0;
const utils_1 = require("../utils");
class UserGroup {
    constructor() {
        this.className = "UserGroup";
        this.name = undefined;
        this.identifier = undefined;
        this.contextId = undefined;
        this.timestamp = undefined;
        this.creationDate = undefined;
        this.groupLeaders = undefined;
    }
    setFromAny(element) {
        const { name, identifier, contextId, timestamp, creationDate, groupLeaders, contextIdRights, contextIds } = element;
        this.contextIds = contextIds ? contextIds : this.contextIds;
        this.contextIdRights = contextIdRights ? contextIdRights : this.contextIdRights;
        this.identifier = identifier ? identifier : this.identifier;
        this.contextId = contextId ? contextId : this.contextId;
        this.name = name ? name : this.name;
        this.groupLeaders = groupLeaders ? groupLeaders : this.groupLeaders;
        this.creationDate = creationDate ? (0, utils_1.isDate)(creationDate) ? creationDate : (0, utils_1.firestoreTimestampToDate)(creationDate) : this.creationDate;
        this.timestamp = timestamp ? (0, utils_1.isDate)(timestamp) ? timestamp : (0, utils_1.firestoreTimestampToDate)(timestamp) : this.timestamp;
    }
    static setFromAny(element) {
        const user = new UserGroup();
        user.setFromAny(element);
        return user;
    }
    searchFilter(filter) {
        const groupLeaders = (0, utils_1.deepCopy)(this.groupLeaders);
        const str = `${this.name}${this.identifier}${groupLeaders === null || groupLeaders === void 0 ? void 0 : groupLeaders.map((l) => l.groupLeaderName)}`.toLowerCase();
        return str.includes(filter.toLowerCase());
    }
    replacerFn(key) {
        const list = ["className"];
        if (list.includes(key))
            return false;
        else
            return true;
    }
    toString() {
        return JSON.stringify(this);
    }
}
exports.UserGroup = UserGroup;
UserGroup.className = "UserGroup";
